import { Message } from "./Message";

export const errorList: Record<Message | string, [string, string]> = {
  [Message.instanceRequired]: ["Instance", "Not found."],
  [Message.instanceIdRequired]: ["Instance", "Id is required."],
  [Message.instanceTypeFolder]: ["Instance", "Type is not folder."],
  [Message.instanceType]: ["Instance", "Type is required."],
  [Message.instancePathLength]: ["Instance", "Path is empty."],
  [Message.userRequired]: ["Session", "You are not authorized."],
  [Message.databaseId]: ["Firebase", "ID not been created."],
};
